{
  "title": "Grafiklar boshqaruvi",
  "actions": {
    "save": "Grafikni saqlash",
    "update": "Yangilash",
    "saveChanges": "Saqlash",
    "revert": "Bekor qilish",
    "saveAsNew": "Nusxa sifatida saqlash"
  },
  "tabs": {
    "label": "Grafiklar",
    "draft": "Yangi grafik",
    "saveAction": "Grafikni saqlash",
    "newAction": "Yangi grafik",
    "delete": "«{{name}}» grafigini o'chirish",
    "unsaved": "saqlanmagan o'zgarishlar bor",
    "rename": "Nomini o'zgartirish",
    "share": "Hamkasblar bilan ulashish",
    "unshare": "Ulashishni to'xtatish",
    "remove": "O'chirish",
    "shared": "{{owner}} ulashgan",
    "renameLabel": "Grafik nomi"
  },
  "panel": {
    "title": "Qurilmalar tanlovi",
    "from": "Boshlanish sanasi",
    "to": "Tugash sanasi",
    "search": "Qurilma nomini izlang",
    "all": "Barchasi",
    "selected": "{{count}} ta tanlangan",
    "clear": "Tozalash",
    "apply": "Qo'llash",
    "noCategory": "Turkumsiz",
    "notFound": "Hech narsa topilmadi",
    "noIndicators": "Obyektda hali ko'rsatkich yo'q",
    "pickDate": "Sanani tanlash",
    "dateInvalid": "Sana noto'g'ri — KK.OO.YYYY",
    "limit": "Bir grafikda {{max}} tadan ortiq ko'rsatkich bo'lmaydi",
    "expand": "{{name}} — ochish",
    "collapse": "{{name}} — yopish"
  },
  "periods": {
    "label": "Davr tanlash",
    "1d": "1 KUN",
    "7d": "7 KUN",
    "30d": "30 KUN",
    "all": "Barchasi",
    "custom": "Maxsus"
  },
  "summary": "{{from}} - {{to}}  -  {{count}} ta o'lchov",
  "views": {
    "label": "Ko'rinish",
    "chart": "Grafik holatida",
    "table": "Jadval holatida"
  },
  "legend": {
    "updated": "Oxirgi yangilanish: {{time}}",
    "toggle": "{{name}} — ko'rsatish yoki yashirish",
    "missing": "{{count}} ta ko'rsatkich topilmadi"
  },
  "kpi": {
    "min": "Min",
    "max": "Max",
    "avg": "O'rt"
  },
  "thresholds": {
    "warning": "Ogohlantirish",
    "danger": "Xavf chegarasi"
  },
  "table": {
    "time": "Vaqt",
    "status": "Holat"
  },
  "status": {
    "normal": "Me'yorda",
    "m1": "Ogohlantirish",
    "m2": "Xavfli"
  },
  "empty": {
    "title": "Ko'rsatkich tanlanmagan",
    "text": "O'ng paneldagi ro'yxatdan ko'rsatkichlarni belgilang va «Qo'llash» tugmasini bosing.",
    "noData": "Tanlangan davrda o'lchovlar yo'q",
    "noDataText": "Boshqa davrni tanlab ko'ring."
  },
  "save": {
    "title": "Grafikni saqlash",
    "name": "Grafik nomi",
    "nameHint": "Nom yuqoridagi tab barda ko'rsatiladi",
    "series": "Tanlangan qurilmalar ({{count}})",
    "seriesSearch": "Tanlanganlar ichidan izlang",
    "seriesHint": "Ro'yxatni aylantiring yoki izlang. Chartda ranglar takrorlanishi mumkin",
    "remove": "«{{name}}» ni olib tashlash",
    "keepPeriod": "Davrni ham saqlash",
    "allPeriod": "Barcha davr",
    "share": "Hamkasblar bilan ulashish",
    "shareHint": "Grafik obyektdagi boshqa xodimlarga ham ko'rinadi",
    "saved": "Grafik saqlandi",
    "savedText": "\"{{name}}\" yuqoridagi tab barga qo'shildi",
    "updated": "O'zgarishlar saqlandi",
    "nameTaken": "Bunday nomli grafik mavjud",
    "nameRequired": "Grafik nomini kiriting",
    "noSeries": "Kamida bitta ko'rsatkich tanlang",
    "cancel": "Bekor qilish",
    "submit": "Saqlash"
  },
  "delete": {
    "title": "Grafikni o'chirish?",
    "text": "«{{name}}» grafigi o'chiriladi.",
    "confirm": "O'chirish",
    "done": "Grafik o'chirildi"
  },
  "rename": {
    "saved": "Nomi o'zgartirildi"
  },
  "share": {
    "on": "Grafik ulashildi",
    "off": "Ulashish to'xtatildi"
  },
  "refreshed": "Ma'lumotlar yangilandi",
  "error": {
    "load": "Ma'lumotlarni yuklab bo'lmadi",
    "retry": "Qayta urinish",
    "generic": "Xatolik yuz berdi"
  },
  "common": {
    "close": "Yopish",
    "cancel": "Bekor qilish"
  }
}
